const masterlist = {
    cable1: {
      name: "USB-C to Micro-B",
      visible: true,
      protocol: "usb",
      audio: false,
      video: false,
      data: true,
      connectorType: "usb",
      connectorSize: ["usb-micro-b", "usb-c"],
      length: 3,
      dongle: false,
      image: "/images/usb-c-to-micro-b.jpg",
      quantity: 2,
      location: "Bin C"
    },
    cable1m: {
      name: "USB-C to USB-A Cable",
      visible: true,
      protocol: "usb",
      audio: false,
      video: false,
      data: true,
      connectorType: "usb",
      connectorSize: ["usb-a", "usb-c"],
      length: 6,
      dongle: false,
      image: "/images/usba-to-c.jpg",
      quantity: 2,
      location: "One is with the Native Union qi charger, the other is in Bin C"
    },
    cable1n: {
      name: "USB-C Cable",
      visible: true,
      protocol: "usb",
      audio: false,
      video: false,
      data: true,
      connectorType: "usb",
      connectorSize: ["usb-c"],
      length: 6,
      dongle: false,
      image: "/images/usbc.jpg",
      quantity: 1,
      location: "Connected to the charger for the MacBook Pro"
    },
    cable2m: {
      name: "3.5mm Splitter Duplicator",
      visible: true,
      protocol: "Analog",
      audio: true,
      video: false,
      data: false,
      connectorType: "trs",
      connectorSize: ["3.5mm"],
      length: 0.5,
      dongle: false,
      image: "/images/35-splitter-stereo-s.jpg",
      quantity: 1,
      location: "Bin AV"
    },
    cable2n: {
      name: "3.5mm Splitter L/R",
      visible: true,
      protocol: "Analog",
      audio: true,
      video: false,
      data: false,
      connectorType: "trs",
      connectorSize: ["3.5mm"],
      length: 0.5,
      dongle: false,
      image: "/images/35mm-split-l-r.jpg",
      quantity: 1,
      location: "On the desk"
    },
    
    cable9: {
      name: "USB-C to Lightning Cable",
      visible: true,
      protocol: "Lightning, USB",
      audio: false,
      video: false,
      data: true,
      connectorType: "Lightning, USB-C",
      connectorSize: ["lightning", "usb-c"],
      length: 4,
      dongle: false,
      image: "/images/lightning-usb-c.jpg",
      quantity: 1,
      location: "Bin C"
    },
    cable9b: {
      name: "USB-A to Lightning",
      visible: true,
      protocol: "Lightning, USB",
      audio: false,
      video: false,
      data: true,
      connectorType: "Lightning, USB-A",
      connectorSize: ["lightning", "usb-a"],
      length: "1 to 10",
      dongle: false,
      image: "/images/lightning-to-usb-sm.jpg",
      quantity: 4,
      location: "Two are in Bin U, two in Bin C"
    },
    cable3: {
      name: "HDMI Cable",
      visible: true,
      protocol: "HDMI",
      audio: true,
      video: true,
      data: false,
      connectorType: "HDMI",
      connectorSize: ["hdmi type a"],
      length: "4 to 20",
      dongle: false,
      image: "/images/hdmi-sm.jpg",
      quantity: 4,
      location: "Two are in use near the TV, the other two, including the 20-foot one, are in Bin C"
    },
   
    cable5: {
      name: "3.5mm Extension Cable Mono",
      visible: true,
      protocol: "analog",
      audio: true,
      video: false,
      data: false,
      connectorType: "trs",
      connectorSize: ["3.5mm"],
      length: "3 to 10",
      dongle: false,
      image: "/images/3-5mm-extension-sm.jpg",
      quantity: 3,
      location: "Bin AV. Note that the longer one is male-female, the other two are male-male."
    },
    cable5m: {
      name: "3.5mm Extension Cable Stereo",
      visible: true,
      protocol: "analog",
      audio: true,
      video: false,
      data: false,
      connectorType: "trs",
      connectorSize: ["3.5mm"],
      length: 3,
      dongle: false,
      image: "/images/35mm-stereo-extension.jpg",
      quantity: 1,
      location: "On the desk"
    },
    cable8: {
      name: "Ethernet Cable",
      visible: true,
      protocol: "Ethernet",
      audio: false,
      video: false,
      data: true,
      connectorType: "ethernet",
      connectorSize: ["ethernet"],
      length: "4 to 6",
      dongle: false,
      image: "/images/ethernet.jpg",
      quantity: 2,
      location: "Bin RB"
    },
    cable6: {
      name: "RCA Component Video Cable",
      visible: true,
      protocol: "Component",
      audio: false,
      video: true,
      data: false,
      connectorType: "rca",
      connectorSize: ["rca"],
      length: 8,
      dongle: false,
      image: "/images/component-rca-sm.jpg",
      quantity: 1,
      location: "Bin AV"
    },
    cable6b: {
      name: "RCA Video/Audio to 3.5mm",
      visible: true,
      protocol: "Analog",
      audio: true,
      video: true,
      data: false,
      connectorType: "rca, trs",
      connectorSize: ["rca", "3.5mm"],
      length: 5,
      dongle: false,
      image: "/images/rca-to-35-s.jpg",
      quantity: 1,
      location: "Bin AV"
    },
    cable6d: {
      name: "RCA Video/Audio to Canon AV",
      visible: true,
      protocol: "Analog",
      audio: true,
      video: true,
      data: false,
      connectorType: "rca, Canon AV",
      connectorSize: ["rca", "canon av"],
      length: 4,
      dongle: false,
      image: "/images/rca-to-canon.jpg",
      quantity: 1,
      location: "Bin AV"
    },
    cable7: {
      name: "RCA Double Cable",
      visible: true,
      protocol: "Composite",
      audio: true,
      video: true,
      data: false,
      connectorType: "rca",
      connectorSize: ["rca"],
      length: 4,
      dongle: false,
      image: "/images/two-rca.jpg",
      quantity: 1,
      location: "In use, plugged in to VCR"
    },

    cable7m: {
      name: "RCA Single Cable",
      visible: true,
      protocol: "Composite",
      audio: true,
      video: true,
      data: false,
      connectorType: "rca",
      connectorSize: ["rca"],
      length: 3,
      dongle: false,
      image: "/images/single-rca.jpg",
      quantity: 1,
      location: "Bin AV"
    },
   cable101: {
      name: "USB-A to Mini-B",
      visible: true,
      protocol: "usb",
      audio: false,
      video: false,
      data: true,
      connectorType: "usb",
      connectorSize: ["usb-mini-b", "usb-a"],
      length: "1 to 5",
      dongle: false,
      image: "/images/a-to-minib-sm.jpg",
      quantity: 16,
      location: "Bin U"
   },
   cable102: {
    name: "Phone Cable",
    visible: true,
    protocol: "phone",
    audio: true,
    video: false,
    data: true,
    connectorType: "Phone",
    connectorSize: ["phone"],
    length: 10,
    dongle: false,
    image: "/images/phone-sm.jpg",
    quantity: 2,
    location: "Bin RB"
 },
 cable2: {
  name: "3.5mm Aux Cable",
  visible: true,
  protocol: "Analog",
  audio: true,
  video: false,
  data: false,
  connectorType: "trs",
  connectorSize: ["3.5mm"],
  length: 6,
  dongle: false,
  image: "/images/aux-sm.jpg",
  quantity: 1,
  location: "Bin C"
},
 cable103: {
  name: "USB-A to Micro-B Dock",
  visible: true,
  protocol: "usb",
  audio: false,
  video: false,
  data: true,
  connectorType: "usb",
  connectorSize: ["usb-micro-b", "usb-a"],
  length: 3,
  dongle: false,
  image: "/images/a-to-dock-sm.jpg",
  quantity: 2,
  location: "Bin U"
},
cable104: {
  name: "USB-A Cable",
  visible: true,
  protocol: "usb",
  audio: false,
  video: false,
  data: true,
  connectorType: "usb",
  connectorSize: ["usb-a"],
  length: 2,
  dongle: false,
  image: "/images/a-to-a-sm.jpg",
  quantity: 1,
  location: "Bin U"
},
cable105: {
  name: "USB-A to Micro-B",
  visible: true,
  protocol: "usb",
  audio: false,
  video: false,
  data: true,
  connectorType: "usb",
  connectorSize: ["usb-micro-b", "usb-a"],
  length: "1 to 4",
  dongle: false,
  image: "/images/a-to-micro-b.jpg",
  quantity: 8,
  location: "5 are in Bin U, two are by hard drives in D3, one is near the PS4"
},
cable106: {
  name: "USB-A to A and Mini-B",
  visible: true,
  protocol: "usb",
  audio: false,
  video: false,
  data: true,
  connectorType: "usb",
  connectorSize: ["usb-mini-b", "usb-a"],
  length: 3,
  dongle: false,
  image: "/images/a-to-a-and-b.jpg",
  quantity: 2,
  location: "One is in Bin C with optical drive, the other is in Bin U"
},
cable107: {
  name: "USB-A to 3.0-Micro-B",
  visible: true,
  protocol: "usb",
  audio: false,
  video: false,
  data: true,
  connectorType: "usb",
  connectorSize: ["usb-3.0-micro-b", "usb-a"],
  length: 1.5,
  dongle: false,
  image: "/images/3dot0-micro-to-A-sm.jpg",
  quantity: 6,
  location: "Two are near the hard drives Elements and Tacitus, and others are by hard drives or readers, and in Bin U"
},
cable108: {
  name: "S-Video to RCA",
  visible: true,
  protocol: "analog",
  audio: false,
  video: true,
  data: false,
  connectorType: "rca, S-Video",
  connectorSize: ["rca", "s-video"],
  length: 0.5,
  dongle: true,
  image: "/images/s-video-to-rca-sm.jpg",
  quantity: 1,
  location: "Bin AV"
},
cable109: {
  name: "USB-A to Apple 30-pin",
  visible: true,
  protocol: "usb",
  audio: false,
  video: false,
  data: true,
  connectorType: "usb, Apple 30-pin",
  connectorSize: ["usb-a", "apple 30-pin"],
  length: 4,
  dongle: false,
  image: "/images/30-pin-to-usb-sm.jpg",
  quantity: 4,
  location: "Bin U"
},
cable110: {
  name: "USB-A to SD Card, Micro SD, MS",
  visible: true,
  protocol: "usb",
  audio: false,
  video: false,
  data: true,
  connectorType: "usb",
  connectorSize: ["usb-a"],
  length: 0.5,
  dongle: true,
  image: "/images/card-reader-SD-sm.jpg",
  quantity: 2,
  location: "Bin U"
},
cable110m: {
  name: "USB-A to CF Card, SD Card, Micro SD, and MS",
  visible: true,
  protocol: "usb",
  audio: false,
  video: false,
  data: true,
  connectorType: "usb",
  connectorSize: ["usb-a"],
  length: 2,
  dongle: true,
  image: "/images/kingston.jpg",
  quantity: 1,
  location: "Bin C"
},
cable111: {
  name: "HDMI to Mini DisplayPort",
  visible: true,
  protocol: "hdmi",
  audio: true,
  video: true,
  data: false,
  connectorType: "hdmi, Mini DisplayPort",
  connectorSize: ["hdmi", "mini displayport"],
  length: 0.5,
  dongle: false,
  image: "/images/hdmi-to-minidisplayport-sm.jpg",
  quantity: 1,
  location: "Bin AV"
},
cable112: {
  name: "Firewire 800 to Thunderbolt (Mini DisplayPort)",
  visible: true,
  protocol: "Firewire, Thunderbolt",
  audio: true,
  video: true,
  data: true,
  connectorType: "Firewire 800, Mini DisplayPort, Thunderbolt",
  connectorSize: ["9-pin", "mini displayport", "thunderbolt"],
  length: 0.5,
  dongle: false,
  image: "/images/firewire-to-thunderbolt-sm.jpg",
  quantity: 1,
  location: "Bin F"
},
cable113: {
  name: "Firewire 800 Cable",
  visible: true,
  protocol: "Firewire",
  audio: true,
  video: true,
  data: true,
  connectorType: "Firewire 800",
  connectorSize: ["9-pin"],
  length: "2 to 5",
  dongle: false,
  image: "/images/firewire-800-sm.jpg",
  quantity: 3,
  location: "Bin F"
},
cable113b: {
  name: "Firewire 400 Cable",
  visible: true,
  protocol: "Firewire",
  audio: true,
  video: true,
  data: true,
  connectorType: "Firewire 400",
  connectorSize: ["6-pin"],
  length: "2 to 5",
  dongle: false,
  image: "/images/firewire400.jpg",
  quantity: 2,
  location: "Bin F"
},
cable114: {
  name: "SATA Cable",
  visible: true,
  protocol: "Serial ATA",
  audio: false,
  video: false,
  data: true,
  connectorType: "SATA",
  connectorSize: ["sata"],
  length: 4,
  dongle: false,
  image: "/images/sata-sm.jpg",
  quantity: 2,
  location: "Bin RB"
},
cable115: {
  name: "Firewire 800 to 400",
  visible: true,
  protocol: "Firewire",
  audio: true,
  video: true,
  data: true,
  connectorType: "Firewire",
  connectorSize: ["9-pin", "6-pin"],
  length: 6,
  dongle: false,
  image: "/images/firewire-800-400-sm.jpg",
  quantity: 4,
  location: "Bin F"
},
cable116: {
  name: "USB-A Extension",
  visible: true,
  protocol: "usb",
  audio: false,
  video: false,
  data: true,
  connectorType: "USB-A",
  connectorSize: ["usb-a"],
  length: 0.5,
  dongle: true,
  image: "/images/usb-extension-sm.jpg",
  quantity: 1,
  location: "Bin U"
},

cable117: {
  name: "3.5mm Audio to 2.5mm Adapter",
  visible: true,
  protocol: "analog",
  audio: true,
  video: false,
  data: false,
  connectorType: "trs",
  connectorSize: ["3.5mm", "2.5mm"],
  length: 0.1,
  dongle: true,
  image: "/images/25-adapter-s.jpg",
  quantity: 1,
  location: "Bin AV"
},
cable10: {
  name: "USB-C to VGA",
  visible: true,
  protocol: "VGA, USB",
  audio: false,
  video: true,
  data: false,
  connectorType: "VGA, USB-C",
  connectorSize: ["vga", "usb-c"],
  length: 0.5,
  dongle: true,
  image: "/images/vga-to-usb-c.jpg",
  quantity: 1,
  location: "Bin AV"
},
cable10b: {
  name: "USB-C to DVI",
  visible: true,
  protocol: "DVI, USB",
  audio: false,
  video: true,
  data: false,
  connectorType: "DVI, USB-C",
  connectorSize: ["dvi", "usb-c"],
  length: 0.5,
  dongle: true,
  image: "/images/dvi-to-usbc.jpg",
  quantity: 1,
  location: "Bin AV"
},
cable10c: {
  name: "DVI to VGA",
  visible: true,
  protocol: "DVI, VGA",
  audio: false,
  video: true,
  data: false,
  connectorType: "DVI, VGA",
  connectorSize: ["dvi", "vga"],
  length: 0.5,
  dongle: true,
  image: "/images/dvi-to-vga-s.jpg",
  quantity: 1,
  location: "Bin AV"
},
cable117b: {
  name: "3.5mm Audio to 1/4-Inch Adapter",
  visible: true,
  protocol: "analog",
  audio: true,
  video: false,
  data: false,
  connectorType: "trs",
  connectorSize: ["3.5mm", "1/4-inch"],
  length: 0.1,
  dongle: true,
  image: "/images/35-to-quarter-inch-s.jpg",
  quantity: 2,
  location: "Bin AV"
},
cable117c: {
  name: "2.5mm Audio to 3.5mm Adapter",
  visible: true,
  protocol: "analog",
  audio: true,
  video: false,
  data: false,
  connectorType: "trs",
  connectorSize: ["3.5mm", "2.5mm"],
  length: 0.1,
  dongle: true,
  image: "/images/25-to-35.jpg",
  quantity: 1,
  location: "Bin AV"
},
cable117d: {
  name: "USB-A to USB-C Adapter",
  visible: true,
  protocol: "analog",
  audio: false,
  video: false,
  data: true,
  connectorType: "usb",
  connectorSize: ["usb-a", "usb-c"],
  length: 0.1,
  dongle: true,
  image: "/images/aukey.jpg",
  quantity: 7,
  location: "Most are attached to USB-A cables right now, such as the 3.0 Micro-B cables and a card reader"
},
cable118: {
  name: "USB-C to Mini-B",
  visible: true,
  protocol: "usb",
  audio: false,
  video: false,
  data: true,
  connectorType: "usb",
  connectorSize: ["usb-mini-b", "usb-c"],
  length: 6,
  dongle: false,
  image: "/images/usb-c-to-mini-b-s.jpg",
  quantity: 1,
  location: "Bin C"
},
cable119: {
  name: "3.5mm Audio to 2.5mm Cable",
  visible: true,
  protocol: "analog",
  audio: false,
  video: false,
  data: true,
  connectorType: "trs",
  connectorSize: ["3.5mm", "2.5mm"],
  length: "5 to 10",
  dongle: false,
  image: "/images/35-to-25-cord-s.jpg",
  quantity: 3,
  notes: "One is currently used in my headphones",
  location: "Bin AV, but one is in use, currently in headphones"
},
cable120: {
  name: "Firewire 800 to 4-pin",
  visible: true,
  protocol: "Firewire",
  audio: true,
  video: true,
  data: true,
  connectorType: "Firewire",
  connectorSize: ["9-pin", "4-pin"],
  length: 6,
  dongle: false,
  image: "/images/firewire-800-to-4pin-s.jpg",
  quantity: 1,
  location: "Bin F"
},
cable121: {
  name: "Firewire 400 to 4-pin",
  visible: true,
  protocol: "Firewire",
  audio: true,
  video: true,
  data: true,
  connectorType: "Firewire",
  connectorSize: ["6-pin", "4-pin"],
  length: 6,
  dongle: false,
  image: "/images/firewire-400t-4pin-s.jpg",
  quantity: 1,
  location: "Bin F"
},

cable122: {
  name: "USB-C to HDMI and USB-A and USB-C",
  visible: true,
  protocol: "usb",
  audio: true,
  video: true,
  data: true,
  connectorType: "usb",
  connectorSize: ["usb-c", "hdmi", "usb-a"],
  length: 0.5,
  dongle: true,
  image: "/images/usbc-to-hdmi2.jpg",
  quantity: 1,
  location: "In my messenger bag"
},
cable123: {
  name: "RCA and S-Video to HDMI",
  visible: true,
  protocol: "usb",
  audio: true,
  video: true,
  data: false,
  connectorType: "rca, s-video, hdmi",
  connectorSize: ["rca", "hdmi", "s-video"],
  length: 0.5,
  dongle: true,
  image: "/images/rca-to-hdmi.jpg",
  quantity: 1,
  location: "Bin C"
},
cable123m: {
  name: "HDMI to USB-C",
  visible: true,
  protocol: "usb",
  audio: true,
  video: true,
  data: true,
  connectorType: "usb, hdmi",
  connectorSize: ["usb-c", "hdmi"],
  length: 6,
  dongle: true,
  image: "/images/hdmi-to-usbc.jpg",
  quantity: 1,
  location: "Bin C"
},
cable124: {
  name: "Lightning to 3.5mm",
  visible: true,
  protocol: "lightning",
  audio: true,
  video: false,
  data: false,
  connectorType: "trs, lightning",
  connectorSize: ["lightning", "3.5mm"],
  length: 0.5,
  dongle: true,
  image: "/images/lightning-to-35.jpg",
  quantity: 1,
  location: "In my messenger bag"
},
cable125: {
  name: "3.5mm Credit Card Reader",
  visible: true,
  protocol: "digital",
  audio: false,
  video: false,
  data: true,
  connectorType: "trs",
  connectorSize: ["3.5mm"],
  length: 0.5,
  dongle: true,
  image: "/images/35-to-credit-card.jpg",
  quantity: 1,
  location: "Bin RB"
},

}

export default masterlist;


// WEBPACK FOOTER //
// ./src/cablelist.js